<template>
    <v-autocomplete
        ref="city"
        v-model="city"
        :disabled="!to.filter.hosp || loading.to.province || loading.to.city"
        :readonly="!to.filter.hosp"
        :clearable="to.filter.hosp"
        color="teal"
        label="City"
        :items="cityItems"
        item-text="city_name"
        item-value="uid"
        return-object
        auto-select-first
        autocomplete="nope"
        :loading="loading.to.province || loading.to.city"
        @click:clear="handleClearCity"
        @change="handleChangeToCity($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title>{{ item.city_name }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.city_region }}, {{ item.city_province }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['to', 'member_model', 'loading'],
    data: () => ({
        city: null
    }),
    computed: {
        ...mapGetters(['getToProvinces', 'getToCities']),
        cityItems() {
            return (this.getToCities || []).map(item => ({
                ...item,
                uid: `${item.city_region}${item.city_province}${item.city_name}`
            }))
        }
    },
    watch: {
        getToProvinces() {
            this.loading.to.province = false
        },
        getToCities() {
            this.loading.to.city = false
        },
        'to.city'(newVal) {
            if (!newVal) {
                this.city = null
                return
            }
            this.city = this.cityItems.find(i => i.city_name === newVal) || null
        }
    },
    methods: {
        ...mapActions(['toHospClin']),
        handleClearCity() {
            this.to.city = null
            this.city = null
        },
        handleChangeToCity(item) {
            if (!item) {
                this.to.city = null
                return
            }
            this.to.city = item.city_name
            this.to.province = item.city_province
            this.to.region = item.city_region
            this.to.facility = ''
            this.to.filter.doc = false
            this.to.specField = { sp_name: 'ALL', sp_desc: '' }
            this.to.hospClinDoctor = ''
            this.to.hospClinType = 'H'
            this.to.decking = ''
            this.toHospClin({
                REGION: item.city_region || '',
                PROVINCE: item.city_province || '',
                CITY: item.city_name || '',
                MEMBN: this.member_model.MEMB_N
            })
        }
    }
}
</script>
